"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CardMedia_1 = __importDefault(require("./CardMedia"));
exports.default = CardMedia_1.default;
